import { useFeatureIsOn } from '@growthbook/growthbook-react'

import { useRecommendedForYouArticlesQuery } from '../../../../../generated/frontend'
import type { RecommendedModelType } from '../../../../../shared/components/RecommendedForYou'
import { getModelsData, Layout, Model } from '../../../../../shared/components/RecommendedForYou'
import { ModelRecommendations } from '../../../../../shared/components/RecommendedForYou/components/ModelRecommendations/ModelRecommendations'

type ContentExperimentProps = {
  recommendedModel: RecommendedModelType
  position: string
}

const ContentExperiment = ({ recommendedModel, position }: ContentExperimentProps) => {
  const showR4U = useFeatureIsOn('DSP-025-most-recent-on-article-pages')

  if (showR4U) {
    return (
      <ModelRecommendations
        model={recommendedModel}
        whichId={'related links'}
        layout={Layout.TextLinks}
        position={position}
      />
    )
  }

  return null
}

type RecommendedForYouArticlesProps = {
  position: string
}

export const RecommendedForYouArticles = ({ position }: RecommendedForYouArticlesProps) => {
  const { data, loading } = useRecommendedForYouArticlesQuery()

  if (loading) {
    return null
  }

  const allModels = getModelsData(data?.homePage.recommendations?.models ?? [])
  const recentCategoryModel = allModels[Model.RECENT_CATEGORY]

  if (recentCategoryModel) {
    return <ContentExperiment recommendedModel={recentCategoryModel} position={position} />
  }

  return null
}
